/*
 * Author: Roger
 * File Created: Monday, 24-08-05 08:51 pm
 * Last Modified: Monday, 24-08-12 11:40 am, by Harper Yan
 */

import { useState } from 'react';

import TypingText from './TypingText';

interface TypingTextGroupProps {
  texts: string[];
}

const TypingTextGroup: React.FC<TypingTextGroupProps> = ({ texts }) => {
  const [index, setIndex] = useState(0);

  const handleTypingFinish = () => {
    setIndex(index + 1);
  };

  return (
    <TypingText
      onFinish={handleTypingFinish}
      speed={100}
      text={texts[index % texts.length]!}
    />
  );
};

export default TypingTextGroup;
